<dt tabindex="0" class="fs-28 bold m-b-50 flex-center cursor-pointer" (click)="toggleTable()">
  {{ headerText }}
  <mat-icon inline="true" class="fs-24 m-l-15">{{ tableVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
</dt>
@if (tableVisible) {
<dd @tableSection class="m-b-20">
  <ng-content></ng-content>
</dd>
}
